import React from 'react'
import assets from '../assets'
import Button from '../Components/Button'
import './index.css'
import { motion } from 'framer-motion'

const Section7 = ({handleActivePopUp, variants}) => {
  return (
    <div className='section automateSec' id='build'>
        <div className="container-lg flex flexCol alignCenter relative">
            <div className="flex flexRow flexWrap selfLeft">
                <motion.h2 
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .3 }}
                viewport={{ once: true }}
                className='iconCorner cornerMob'>
                    Automate, or your<br />
                    business will automate <br />
                    you...
                </motion.h2>
                <div className="flex flexRow alignCenter relative cols justifySpace flexWrap gap">
                    <motion.div
                    variants={variants}
                    initial={'initial'}
                    whileInView={'inView'}
                    transition={{ duration: 0.7, delay: .5 }}
                    viewport={{ once: true }}
                    >
                        {assets.icons.automate}
                    </motion.div>
                    <motion.div
                    variants={variants}
                    initial={'initial'}
                    whileInView={'inView'}
                    transition={{ duration: 0.7, delay: .7 }}
                    viewport={{ once: true }}
                    className="flex flexCol">
                        <p>
                            We help Financial Institutions <strong>Implement automated busines models</strong> globally without the limitation of local subsidiaries trough decentralization. 
                        </p>
                        <p>
                            Merge to digital leveraging, evolve traditional lending rails and do business in a more global, scalable and efficient way through ECON blockchain.
                        </p>
                        <Button link={'#contact'} text={'Build now'} build handleActivePopUp={handleActivePopUp} popData='build' />
                        <Button link={'#contact'} text={'Contact Developers'} handleActivePopUp={handleActivePopUp} popData='white'/>
                    </motion.div>
                </div>
            </div>

        </div>
    </div>
  )
}

export default Section7